import React, {useState, useContext, useEffect} from 'react'
import { Form, FormGroup, Label, Input,
  Button, Modal, ModalBody, ModalHeader, ModalFooter
} from 'reactstrap'
import {Context as AuthContext} from '../../context/AuthContext'

export default function MailerLiteApiKeyModal({toggleModal, isOpen}) {
  const authContext = useContext(AuthContext);
  const {drip_accounts} = authContext.state;
  const {createDripAccount} = authContext;
  const [apiKey, setApiKey] = useState("")
  const [dripAccountId, setDripAccountId] = useState("")


  const handleSubmit = (event) => {
    event.preventDefault();
    createDripAccount(apiKey, dripAccountId)
    toggleModal();
    setApiKey("")
  }

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader toggle={toggleModal}>
        <strong>Drip API Token</strong>
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="apiToken">Account ID</Label>
            <Input type="text" name="drip_account_id" id="drip_account_id"
              placeholder="abc2fasdfl" value={dripAccountId}
              onChange={(event) => setDripAccountId(event.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="apiToken">API Token</Label>
            <Input type="text" name="apiToken" id="apiToken"
              placeholder="abc2fasdfl" value={apiKey}
              onChange={(event) => setApiKey(event.target.value)}
            />
          </FormGroup>
          <Button onClick={handleSubmit} color="warning">Submit</Button>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button onClick={toggleModal} color="primary">Cancel</Button>
      </ModalFooter>
    </Modal>
  )
}
